// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__Qe0s-","withMobileMargins":"DateRangeInput_withMobileMargins__3TaBx","arrowIcon":"DateRangeInput_arrowIcon__1YBTj"};